// src/Datenschutz.js
import React from "react";
import { Link } from "react-router-dom";

export default function Datenschutz() {
  return (
    <div className="bg-white min-h-screen py-16 px-6 text-gray-800">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-center">Datenschutzerklärung</h1>

        <p className="mb-4">
          Wir freuen uns über Ihr Interesse an unserem Webauftritt. Der Schutz Ihrer persönlichen Daten ist uns ein
          wichtiges Anliegen. Nachfolgend informieren wir Sie über die Art, den Umfang und Zweck der Erhebung und
          Verwendung personenbezogener Daten.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Allgemeine Hinweise</h2>
        <p className="mb-4">
          Ihre Daten werden im Rahmen der gesetzlichen Vorschriften geschützt. Personenbezogene Daten werden nur
          erhoben, wenn Sie uns diese im Rahmen einer Kontaktaufnahme freiwillig mitteilen.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Kontaktformular</h2>
        <p className="mb-4">
          Wenn Sie uns per Formular Anfragen zukommen lassen, werden Ihre Angaben inklusive Kontaktdaten zur
          Bearbeitung der Anfrage gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Server-Log-Dateien</h2>
        <p className="mb-4">
          Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien,
          die Ihr Browser automatisch übermittelt.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Auskunft, Löschung, Sperrung</h2>
        <p className="mb-4">
          Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten
          sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Kontakt</h2>
        <p className="mb-4">
          Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten wenden Sie sich bitte an:
          <br />
          <strong>IMENSO GmbH</strong>
          <br />
          Am Bahndamm 6
          <br />
          84100 Niederaichbach
          <br />
          E-Mail: info@imenso.net
        </p>

        <div className="mt-8 text-center">
          <Link to="/" className="text-blue-600 underline hover:text-blue-800">
            Zurück zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}

